import React from 'react';

function Conditions({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" {...props}>
            <path
                d="M11.8969 11.3906C11.3281 12.0719 10.6125 12.5 9.75 12.675V16.5H8.25V12.675C7.3875 12.5 6.67188 12.0719 6.10313 11.3906C5.53437 10.7094 5.25 9.9125 5.25 9C5.25 8.0875 5.53437 7.29062 6.10313 6.60938C6.67188 5.92813 7.3875 5.5 8.25 5.325V1.5H9.75V5.325C10.6125 5.5 11.3281 5.92813 11.8969 6.60938C12.4656 7.29062 12.75 8.0875 12.75 9C12.75 9.9125 12.4656 10.7094 11.8969 11.3906ZM11.25 9C11.25 8.375 11.0313 7.84375 10.5938 7.40625C10.1562 6.96875 9.625 6.75 9 6.75C8.375 6.75 7.84375 6.96875 7.40625 7.40625C6.96875 7.84375 6.75 8.375 6.75 9C6.75 9.625 6.96875 10.1562 7.40625 10.5938C7.84375 11.0313 8.375 11.25 9 11.25C9.625 11.25 10.1562 11.0313 10.5938 10.5938C11.0313 10.1562 11.25 9.625 11.25 9Z"
                fill={color}
            />
        </svg>
    );
}

export default Conditions;
